import IAssignHwrcPermissionsRequest from "interfaces/requests/IAssignHwrcPermissionsRequest";

const initialAssignHwrcPermissionsRequest = () : IAssignHwrcPermissionsRequest => ({
  userId: "",
  applicationId: "",
  regionIds: [],
  roleId: undefined,
  siteIds: []
});

export { initialAssignHwrcPermissionsRequest };
